const TOKEN_KEY = "admin_token";
const USER_KEY = "admin_user";

export const LOGIN_PATH = "/admin";

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getTokenExpiry(
  token: string | null = getToken(),
): number | null {
  if (!token) return null;

  const payload = token.split(".")[1];
  if (!payload) return null;

  try {
    // JWT segments are base64url and unpadded; restore the standard alphabet and
    // the "=" padding before handing them to atob().
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = atob(padded);
    const claims = JSON.parse(json) as { exp?: number };
    return typeof claims.exp === "number" ? claims.exp * 1000 : null;
  } catch {
    return null;
  }
}

export function isSessionExpired(token: string | null = getToken()): boolean {
  if (!token) return true;
  const expiresAt = getTokenExpiry(token);
  if (expiresAt === null) return true;
  return Date.now() >= expiresAt;
}

/** Milliseconds until the current token expires; 0 if it already has. */
export function millisUntilExpiry(token: string | null = getToken()): number {
  const expiresAt = getTokenExpiry(token);
  if (expiresAt === null) return 0;
  return Math.max(0, expiresAt - Date.now());
}

export function clearSession(): void {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}
let redirecting = false;
export function redirectToLogin({
  expired = false,
}: { expired?: boolean } = {}): void {
  clearSession();

  if (redirecting) return;
  redirecting = true;

  const target = expired ? `${LOGIN_PATH}?session=expired` : LOGIN_PATH;
  window.location.replace(target);
}
